module.exports = __webpack_public_path__ + "img/emo_01.d6bb2c49.png";